export const MEBIBYTE = 1024 * 1024;

// These limits mirror PeticionCargarFactura in the API.
export const INVOICE_UPLOAD_LIMITS = Object.freeze({
  factura: 1 * MEBIBYTE,
  xml: 1 * MEBIBYTE,
  soporte: 10 * MEBIBYTE,
  contenidoNacional: 1 * MEBIBYTE,
  repse: 1 * MEBIBYTE
});

export const PDF_MIME_TYPES = Object.freeze(['application/pdf']);
export const XML_MIME_TYPES = Object.freeze(['application/xml', 'text/xml']);

export function formatFileSize(bytes) {
  const mebibytes = bytes / MEBIBYTE;
  return `${Number.isInteger(mebibytes) ? mebibytes : mebibytes.toFixed(1)} MB`;
}

export function requiredRule(label) {
  return value => Boolean(value) || `${label} es requerido.`;
}

export function fileSizeRule(maxBytes) {
  return file => !file || file.size <= maxBytes ||
    `El tamaño máximo permitido es de ${formatFileSize(maxBytes)}.`;
}

export function fileTypeRule(allowedMimeTypes, extensionLabel) {
  return file => !file || allowedMimeTypes.includes(file.type) ||
    `El archivo debe tener formato ${extensionLabel}.`;
}

export async function createFileSnapshot(file) {
  if (!file) return null;

  try {
    const content = await file.arrayBuffer();
    return new File([content], file.name, {
      type: file.type,
      lastModified: file.lastModified
    });
  } catch (error) {
    const snapshotError = new Error(`No fue posible leer el archivo "${file.name}".`);
    snapshotError.code = 'UPLOAD_FILE_UNREADABLE';
    snapshotError.filename = file.name;
    snapshotError.cause = error;
    throw snapshotError;
  }
}
